"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPhoneLoginDto = instanceOfPhoneLoginDto;
exports.PhoneLoginDtoFromJSON = PhoneLoginDtoFromJSON;
exports.PhoneLoginDtoFromJSONTyped = PhoneLoginDtoFromJSONTyped;
exports.PhoneLoginDtoToJSON = PhoneLoginDtoToJSON;
exports.PhoneLoginDtoToJSONTyped = PhoneLoginDtoToJSONTyped;
/**
 * Check if a given object implements the PhoneLoginDto interface.
 */
function instanceOfPhoneLoginDto(value) {
    if (!('firebaseIdToken' in value) || value['firebaseIdToken'] === undefined)
        return false;
    return true;
}
function PhoneLoginDtoFromJSON(json) {
    return PhoneLoginDtoFromJSONTyped(json, false);
}
function PhoneLoginDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firebaseIdToken': json['firebaseIdToken'],
        'visitorId': json['visitorId'] == null ? undefined : json['visitorId'],
        'deviceFingerprint': json['deviceFingerprint'] == null ? undefined : json['deviceFingerprint'],
    };
}
function PhoneLoginDtoToJSON(json) {
    return PhoneLoginDtoToJSONTyped(json, false);
}
function PhoneLoginDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'firebaseIdToken': value['firebaseIdToken'],
        'visitorId': value['visitorId'],
        'deviceFingerprint': value['deviceFingerprint'],
    };
}
